import Popover from "stimulus-popover";
import { useClickOutside } from "stimulus-use";
import { computePosition, autoPlacement } from "@floating-ui/dom";
import { auto } from "@cloudinary/url-gen/qualifiers/quality";

const MOBILE_MAX_WIDTH = 639;

export default class extends Popover {
  // static targets = this.targets.concat(['anchor'])
  static values = { placement: String, autoplacement: Boolean, noMobileFullscreen: Boolean }

  connect() {
    super.connect();
  }

  disconnect() {
    if (this.hasCardTarget) {
      // Éviter que le truc reste là en cas de retour sur la page
      this.hide()
    }
    super.disconnect();
  }

  isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
  }

  setupMobileFullscreen() {
    this.mobileMode = true;
    this.cardTarget.classList.add("floating-menu-mobile-fullscreen");

    const header = document.createElement("div");
    header.className = "floating-menu-mobile-header";

    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "floating-menu-mobile-close";
    closeBtn.setAttribute("aria-label", "Fermer");
    closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>`;
    closeBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      this.hide();
    });

    header.appendChild(closeBtn);
    this.cardTarget.prepend(header);

    this.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }

  // On recopie la méthode show de Popover pour pouvoir l'adapter (ajout d'une anchor séparée)
  async show(event) {
    event.preventDefault()
    // Temporally variable to prevent `event.currentTarget` to being null.
    let content = null;
    let anchor = this.element;

    if (this.hasContentTarget) {
      content = this.contentTarget.innerHTML;
    } else {
      content = await this.fetch();
    }

    if (!content) return;

    const fragment = document.createRange().createContextualFragment(content);

    anchor.appendChild(fragment);


    if (this.hasCardTarget) {
      if (this.isMobile() && !this.noMobileFullscreenValue) {
        this.setupMobileFullscreen();
      } else {
        // on utilise floating ui pour positionner le popover
        computePosition(anchor, this.cardTarget, {
          placement: "bottom-start" || "right", middleware: [this.autoplacementValue && autoPlacement()]
        }).then(({ x, y }) => {
          Object.assign(this.cardTarget.style, {
            left: `${x}px`,
            top: `${y}px`,
          });
        });
      }
      // On installe le clickOutside
      useClickOutside(this, { element: this.cardTarget });
    }
  }

  clickOutside() {
    this.hide();
  }

  hide(e) {
    if (this.mobileMode) {
      document.body.style.overflow = this.previousBodyOverflow || "";
      this.mobileMode = false;
    }
    super.hide()
  }

}
